// extracted by mini-css-extract-plugin
module.exports = {"invoice":"Index-module__invoice___19rbR"};